import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DateUtilService, gungEnsureHttp } from 'gung-common';
import { ListItemRendererComponent } from 'gung-list';
import { first, Subject } from 'rxjs';
import { Order } from '../../models/order';
import { AuthService } from '../../services/auth/auth.service';
import { BackendInterceptor } from '../../services/backend-interceptor/backend-interceptor.service';
import { LocationConfigService } from '../../services/location-config/location-config.service';

@Component({
  selector: 'lib-open-order-table',
  templateUrl: './open-order-table.component.html',
  styleUrls: ['./open-order-table.component.css'],
  standalone: false
})
export class OpenOrderTableComponent extends ListItemRendererComponent<Order[]> implements OnInit, AfterViewInit {
  protected locationConfigService = inject(LocationConfigService);
  protected router = inject(Router);
  public dateUtilService = inject(DateUtilService);
  protected authService = inject(AuthService);
  protected backendInterceptor = inject(BackendInterceptor);

  adjustedScroll = false;
  protected unsubscribe: Subject<void> = new Subject();
  isSales = false;
  public baseUrl = this.backendInterceptor.getBaseUrl();

  ngOnInit() {
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isSales = roles.includes('SALES');
      });
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  goToDetail(order: Order): void {
    const url = `/orders/${order.id}`;
    this.router.navigate([url]);
  }

  ensureHttp(url: string): string {
    return gungEnsureHttp(url);
  }
}
